import type { ConnectError } from '@connectrpc/connect'
import {
  BusinessMasterErrorReason,
  BusinessMasterErrorReasonSchema,
} from '@ebalance/proto/bffuser/v1/occto_master_model_pb'
import type { TFunction } from 'i18next'

import {
  type AppErrorInfoReasonEntry,
  type AppErrorInfoResolution,
  resolveAppErrorInfoMessage,
} from '~/libs/appErrorInfo'

/**
 * `BusinessMasterErrorReason` (occto-master-registration-number 設計書
 * Decision #4, backend `occtomaster` domain) → i18n key registry for the
 * BusinessMaster Create/Update modals. Operation-scoped: registration_number
 * duplicate is a cross-record check, not a single-field-at-fault violation.
 */
const BUSINESS_MASTER_REASON_KEYS: Record<
  BusinessMasterErrorReason,
  AppErrorInfoReasonEntry | undefined
> = {
  [BusinessMasterErrorReason.UNSPECIFIED]: undefined,
  [BusinessMasterErrorReason.REGISTRATION_NUMBER_ALREADY_EXISTS]: {
    key: 'page:adminOcctoMaster.serverError.reason.businessMasterRegistrationNumberAlreadyExists',
  },
}

/**
 * `resolveDetailedError` for BusinessMaster's `useCrudModalForm` (Create /
 * Update). Resolves the `google.rpc.ErrorInfo` Connect error detail, if
 * any, against `BUSINESS_MASTER_REASON_KEYS` via the
 * `BusinessMasterErrorReasonSchema` reflection lookup.
 */
export function resolveBusinessMasterDetailedError(
  err: ConnectError,
  t: TFunction,
): AppErrorInfoResolution | undefined {
  return resolveAppErrorInfoMessage(
    err,
    BusinessMasterErrorReasonSchema,
    BUSINESS_MASTER_REASON_KEYS,
    t,
  )
}
